import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { format } from "date-fns";
import { es } from "date-fns/locale"; // Para manejar el idioma español
import { api_v3_get_streamings_by_tournament } from "../../utils/constants";
import { Loading } from "../../components";

const Streamings = ({ tournamentId }) => {
  const [loadingStreamings, setLoadingStreamings] = useState(false);
  const [streamings, setStreamings] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [availableDates, setAvailableDates] = useState([]);

  useEffect(() => {
    setLoadingStreamings(true);
    axios
      .get(api_v3_get_streamings_by_tournament(tournamentId))
      .then((res) => {
        setLoadingStreamings(false);
        const streamingsData = res.data;

        // Obtener fechas únicas de los streamings
        const dates = Array.from(
          new Set(
            streamingsData.map((streaming) =>
              format(
                new Date(streaming.streamingDate || streaming.matchDate),
                "yyyy-MM-dd"
              )
            )
          )
        ).sort((a, b) => new Date(a) - new Date(b)); // Ordenar fechas

        setAvailableDates(dates);
        setStreamings(streamingsData);

        // Seleccionar la fecha actual o la más cercana
        const today = format(new Date(), "yyyy-MM-dd");
        if (dates.includes(today)) {
          setSelectedDate(today);
        } else {
          // Seleccionar la fecha más cercana (pasada o futura)
          const closestDate = dates.reduce((prev, curr) => {
            const currDate = new Date(curr);
            const prevDate = new Date(prev);
            return Math.abs(currDate - new Date()) <
              Math.abs(prevDate - new Date())
              ? curr
              : prev;
          });
          setSelectedDate(closestDate);
        }
      })
      .catch((err) => {
        setLoadingStreamings(false);
      });
  }, [tournamentId]);

  const handleDateClick = (date) => {
    setSelectedDate(date);
  };

  if (loadingStreamings) {
    return <Loading />;
  }

  const filteredStreamings = streamings.filter(
    (streaming) =>
      format(
        new Date(streaming.streamingDate || streaming.matchDate),
        "yyyy-MM-dd"
      ) === selectedDate
  );

  return (
    <Wrapper>
      <Calendar>
        <CalendarList>
          {availableDates.map((date) => (
            <div
              key={date}
              className={`calendar-item ${
                date === selectedDate ? "selected" : ""
              }`}
              onClick={() => handleDateClick(date)}
            >
              <div className="week-day">
                {format(new Date(date), "EEE", { locale: es })}
              </div>
              <div className="day">{format(new Date(date), "dd")}</div>
              <div className="month">
                {format(new Date(date), "MMM", { locale: es })}
              </div>
            </div>
          ))}
        </CalendarList>
      </Calendar>
      <StreamingList>
        {filteredStreamings.length > 0 ? (
          filteredStreamings.map((streaming) => (
            <Streaming key={streaming.matchStreamingId}>
              <div className="first-row">
                <img
                  className="streamer-photo"
                  src={streaming.streamerPhoto}
                  alt={streaming.streamerUsername}
                />
                <h2>{streaming.streamerUsername}</h2>
              </div>
              <div>
                <p>
                  {streaming.streamingDate || streaming.matchDate} en{" "}
                  {streaming.streamingType}
                </p>
              </div>
              <div>{streaming.playerAusername}</div>
              <div>vs</div>
              <div>{streaming.playerBusername}</div>
            </Streaming>
          ))
        ) : (
          <p>No hay streamings para este día.</p>
        )}
      </StreamingList>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-left: 1rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: start;
  overflow: hidden;
  margin-bottom: 2rem;
`;

const Calendar = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
`;

const CalendarList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  overflow-x: auto;
  scroll-behavior: smooth;

  .calendar-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 6rem;
    margin: 1rem;
    padding: 0.5rem;
    background-color: var(--clr-grey-c);
    border: 1px solid var(--clr-grey-d);
    border-radius: 10px;
    cursor: pointer;

    &.selected {
      border-color: violet;
    }
  }

  .week-day {
    font-size: 1rem;
  }

  .day {
    font-size: 2rem;
  }

  .month {
    font-size: 1rem;
  }
`;

const StreamingList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  overflow-x: auto;
  scroll-behavior: smooth;
  width: 100%;
`;

const Streaming = styled.div`
  width: 30vw;
  min-width: 30vw;
  height: 50vh;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0.5rem;
  border: 1px solid var(--clr-yellow-light);
  border-radius: 8px;

  h2 {
    font-size: 1.5rem;
  }

  .first-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 3rem;
  }
  .streamer-photo {
    border-radius: 50%;
    width: 4rem;
    height: 4rem;
    margin-right: 1rem;
  }

  @media (max-width: 650px) {
    height: 25vh;
  }
`;

export default Streamings;
